import { createFileRoute, redirect } from '@tanstack/react-router';
import { agreementSectionPath } from '@/lib/agreement-sections';
import { parseAgreementType, type AgreementTypeSearch } from '@/lib/agreement-type-search';
import { QUALIFIED_TYPES, type QualifiedType } from '@/features/customers-service-agreements/types';

/**
 * The cars to sell agreements for have a page per sales type, in the type's sidebar section; the
 * bare address — old links, `?type=` deep links — lands on the type's page.
 */
export const Route = createFileRoute('/_app/service-agreement/customers/')({
  staticData: { featureKey: 'customers-service-agreements' },
  validateSearch: (search: Record<string, unknown>): AgreementTypeSearch<QualifiedType> =>
    parseAgreementType(search, QUALIFIED_TYPES),
  beforeLoad: ({ search }) => {
    throw redirect({ href: agreementSectionPath('customers', search.type), replace: true });
  },
});
